import { LoadablePaint } from '@confluence/loadable';

export const ForgeSpacePageExtensionPoint = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpacePage" */ './SpacePage')).SpacePage,
});
